module.exports = __webpack_public_path__ + "static/assets/limenke-status.ccfe3695.png";